import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Grid } from '@mui/material';
import { FormChipList } from 'components/common';

const TemplateTag = ({ methods, policies, fieldData, isLoaded, showActions = true }) => {
  const [t] = useTranslation();
  const { control, setValue, getValues } = methods;

  const fieldTags = [
    { ...policies.tagsJob, defaultValue: getValues('tagsJob') },
    { ...policies.tagsSkip, defaultValue: getValues('tagsSkip') },
    { ...policies.tags, defaultValue: getValues('tags') }
  ];

  const handleOnChange = (name) => {
    return (value) => setValue(name, value);
  };

  return (
    <Box
      sx={{ overflow: 'hidden' }}
    >
      {showActions &&
        <Typography variant="h6" sx={{ padding: '8px 0px' }}>
          {t('templateList.stepper.tag.title')}
        </Typography>
      }
      <Grid container spacing={2}>
        { fieldTags.map((chipField, index) => (
          <Grid item xs={12} sm={12} md={6} lg={4} key={index}>
            <FormChipList
              {...chipField}
              control={control}
              onChange={handleOnChange(chipField.name)}
              showActions={showActions}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TemplateTag;
